<template>
  <div>
    <div class="calc-body">
      <div class="calc-head">
        <img src="../assets/images/btn_bg.png" class="bg-btn" />
        <img src="../assets/images/logo.png" class="head-logo" />
        <span>业务收费计算软件</span>
        <div class="head-time">
          <img src="../assets/images/time.png" class="head-time-icon" />
          <span>当前时间：</span>
          <span class="head-time-num">{{hourse}}:{{min}}:{{sencond}}</span>
        </div>
      </div>
      <div class="calc-content">
        <div class="calc-form">
          <div><img src="../assets/images/money.png" class="total-icon" />资产总额：（万元）</div>
          <div class="calc-input">
            <input type="number" placeholder="请输入资产总额" v-model="total" @blur="changeTotal()"/>
            <button class="calc-res" @click="submit()">计算</button>
            <button class="calc-reset" @click="reset()">重置</button>
          </div>
        </div>
        <div class="calc-form">
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-red">
                <img src="../assets/images/icon01.png" />资产评估
              </button>
            </div>
            <div class="calc-input calc-input-res">
              <input type="number" class="calc-res-input" readonly v-model="total1" />
              <span>元</span>
            </div>
          </div>
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-yellow">
                <img src="../assets/images/icon02.png" />会计报表审计
              </button>
            </div>
            <div class="calc-input calc-input-res">
              <input type="number" class="calc-res-input" readonly v-model="total2" />
              <span>元</span>
            </div>
          </div>
        </div>
        <div class="calc-form">
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-red">
                <img src="../assets/images/icon03.png" />设立企业验资
              </button>
            </div>
            <div class="calc-input calc-input-res">
              <input type="number" class="calc-res-input" readonly v-model="total3" />
              <span>元</span>
            </div>
          </div>
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-yellow">
                <img src="../assets/images/icon04.png" />经济责任审计
              </button>
            </div>
            <div class="calc-input calc-input-res">
              <input type="number" class="calc-res-input" readonly v-model="total4" />
              <span>元</span>
            </div>
          </div>
        </div>
        <div class="calc-form">
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-red">
                <img src="../assets/images/icon05.png" />企业清产核资
              </button>
            </div>
            <div class="calc-input calc-input-res">
              <input type="number" class="calc-res-input" readonly v-model="total5" />
              <span>元</span>
            </div>
          </div>
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-yellow">
                <img src="../assets/images/icon06.png" />财务收支审计
              </button>
            </div>
            <div class="calc-input calc-input-res">
              <input type="number" class="calc-res-input" readonly v-model="total6" />
              <span>元</span>
            </div>
          </div>
        </div>
        <div class="calc-form">
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-red">
                <img src="../assets/images/icon07.png" />涉及经济案件审计
              </button>
            </div>
            <div class="calc-input-area">
              <div class="calc-input calc-input-res">
                <input type="number" class="calc-res-input" readonly v-model="total7" />
                <span>元</span>
              </div>
              <div class="calc-jian">-</div>
              <span class="calc-jian1">|</span>
              <div class="calc-input calc-input-res">
                <input type="number" class="calc-res-input" readonly v-model="total8" />
                <span>元</span>
              </div>
            </div>
          </div>
          <div class="calc-form-item">
            <div>
              <button class="other-btn btn-yellow">
                <img src="../assets/images/icon08.png" />建设项目财务审计
              </button>
            </div>
            <div class="calc-input-area">
              <div class="calc-input calc-input-res">
                <input type="number" class="calc-res-input" readonly v-model="total9" />
                <span>元</span>
              </div>
              <div class="calc-jian">-</div>
              <span class="calc-jian1">|</span>
              <div class="calc-input calc-input-res">
                <input type="number" class="calc-res-input" readonly v-model="total10" />
                <span>元</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="calc-footer">
        <span>*备注：</span>
        <span>参考安徽省物价局财务厅文件（皖价服〔2010〕194 号）</span>
        <span>
          技术支持：
          <a href="http://www.jyecloud.cn/" target="_blank" >合肥景烨网络科技有限公司</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      total: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      total9: "",
      total10: "",
      hourse: "",
      min: "",
      sencond: "",
    };
  },
  mounted(){
    this.getTime();
    setInterval(() => {
      this.getTime();
    }, 1000);
  },
  methods:{
    changeTotal(){
      var num = parseFloat(this.total);
      num = num.toFixed(2);
      this.total = num;
    },
    //计算
    submit(){
      if(this.total == '' || this.total == 'NaN')return false;
      this.calcTotal1();
      this.calcTotal2();
      this.calcTotal3();
      this.calcTotal4();
      this.calcTotal5();
      this.calcTotal6();
      this.calcTotal7();
      this.calcTotal9();
    },
    //计算资产评估
    calcTotal1(){
      var num = this.total;
      if(num <= 100) {
        this.total1 = num * 9 / 1000;
      }
      if(num > 100 && num <= 1000) {
        var num_1 = 100 * 9 / 1000;
        var num_2 = (num - 100) * 4 / 1000;
        this.total1 = num_1 + num_2;
      }
      if(num > 1000 && num <= 5000) {
        var num_1 = 100 * 9 / 1000;
        var num_2 = 900 * 4 / 1000;
        var num_3 = (num - 1000) * 1.2 / 1000;
        this.total1 = num_1 + num_2 + num_3;
      }
      if(num > 5000 && num <= 10000) {
        var num_1 = 100 * 9 / 1000;
        var num_2 = 900 * 4 / 1000;
        var num_3 = 4000 * 1.2 / 1000;
        var num_4 = (num - 5000) * 0.75 / 1000;
        this.total1 = num_1 + num_2 + num_3 + num_4;

      }
      if(num > 10000 && num <= 100000) {
        var num_1 = 100 * 9 / 1000;
        var num_2 = 900 * 4 / 1000;
        var num_3 = 4000 * 1.2 / 1000;
        var num_4 = 5000 * 0.75 / 1000;
        var num_5 = (num - 10000) * 0.15 / 1000;
        this.total1 = num_1 + num_2 + num_3 + num_4 + num_5;
      }
      if(num > 100000) {
        var num_1 = 100 * 9 / 1000;
        var num_2 = 900 * 4 / 1000;
        var num_3 = 4000 * 1.2 / 1000;
        var num_4 = 5000 * 0.75 / 1000;
        var num_5 = 90000 * 0.15 / 1000;
        var num_6 = (num - 100000) * 0.1 / 1000;
        this.total1 = num_1 + num_2 + num_3 + num_4 + num_5 + num_6;
      }
      this.total1 = this.total1 * 10000;
      if(this.total1 < 2000)this.total1 = 2000;
      this.total1 = Math.round(this.total1);
    },
    //计算会计报表审计
    calcTotal2(){
      var num = this.total;
      if(num <= 50) {
        this.total2 = 1200;
      }
      if(num > 50 && num <= 100) {
        this.total2 = 1200 + 2000;
      }
      if(num > 100 && num <= 500) {
        this.total2 = 1200 + 2000 + 3000;
      }
      if(num > 500 && num <= 1000) {
        this.total2 = 1200 + 2000 + 3000 + ((num - 500) * 0.4 / 1000 * 10000);
      }
      if(num > 1000 && num <= 5000) {
        this.total2 = 1200 + 2000 + 3000 + (500 * 0.4 / 1000 * 10000) + ((num - 1000) * 0.3 / 1000 * 10000);
      }
      if(num > 5000 && num <= 10000) {
        this.total2 = 1200 + 2000 + 3000 + (500 * 0.4 / 1000 * 10000) + (4000 * 0.3 / 1000 * 10000) + ((num - 5000) * 0.2 / 1000 * 10000);
      }
      if(num > 10000 && num <= 50000) {
        this.total2 = 1200 + 2000 + 3000 + (500 * 0.4 / 1000 * 10000) + (4000 * 0.3 / 1000 * 10000) + (5000 * 0.2 / 1000 * 10000) + ((num - 10000) * 0.15 / 1000 * 10000);
      }
      if(num > 50000 && num <= 100000) {
        this.total2 = 1200 + 2000 + 3000 + (500 * 0.4 / 1000 * 10000) + (4000 * 0.3 / 1000 * 10000) + (5000 * 0.2 / 1000 * 10000) + (40000 * 0.15 / 1000 * 10000) + ((num - 50000) * 0.1 / 1000 * 10000);
      }
      if(num > 100000 && num <= 1000000) {
        this.total2 = 1200 + 2000 + 3000 + (500 * 0.4 / 1000 * 10000) + (4000 * 0.3 / 1000 * 10000) + (5000 * 0.2 / 1000 * 10000) + (40000 * 0.15 / 1000 * 10000) + (50000 * 0.1 / 1000 * 10000) + ((num - 100000) * 0.05 / 1000 * 10000);
      }
      this.total2 = Math.round(this.total2);
    },
    //计算设立企业验资
    calcTotal3(){
      var num = this.total;
      if(num <= 50) {
        this.total3 = 800;
      }
      if(num > 50 && num <= 100) {
        this.total3 = 1200 + 800;
      }
      if(num > 100 && num <= 500) {
        this.total3 = 1200 + 800 + 2000;
      }
      if(num > 500 && num <= 1000) {
        this.total3 = 1200 + 800 + 2000 + ((num - 500) * 0.3 / 1000 * 10000);
      }
      if(num > 1000 && num <= 5000) {
        this.total3 = 1200 + 800 + 2000 + (500 * 0.3 / 1000 * 10000) + ((num - 1000) * 0.2 / 1000 * 10000);
      }
      if(num > 5000 && num <= 10000) {
        this.total3 = 1200 + 800 + 2000 + (500 * 0.3 / 1000 * 10000) + (4000 * 0.2 / 1000 * 10000) + ((num - 5000) * 0.15 / 1000 * 10000);
      }
      if(num > 10000 && num <= 50000) {
        this.total3 = 1200 + 800 + 2000 + (500 * 0.3 / 1000 * 10000) + (4000 * 0.2 / 1000 * 10000) + (5000 * 0.15 / 1000 * 10000) + ((num - 10000) * 0.1 / 1000 * 10000);
      }
      if(num > 50000 && num <= 100000) {
        this.total3 = 1200 + 800 + 2000 + (500 * 0.3 / 1000 * 10000) + (4000 * 0.2 / 1000 * 10000) + (5000 * 0.15 / 1000 * 10000) + (40000 * 0.1 / 1000 * 10000) + ((num - 50000) * 0.05 / 1000 * 10000);
      }
      if(num > 100000 && num <= 1000000) {
        this.total3 = 1200 + 800 + 2000 + (500 * 0.3 / 1000 * 10000) + (4000 * 0.2 / 1000 * 10000) + (5000 * 0.15 / 1000 * 10000) + (40000 * 0.1 / 1000 * 10000) + (50000 * 0.05 / 1000 * 10000) + ((num - 100000) * 0.025 / 1000 * 10000);
      }
      this.total3 = Math.round(this.total3);
    },
    //计算经济责任审计
    calcTotal4(){
      this.total4 = this.total2 * 1.2;
      this.total4 = Math.round(this.total4);
    },
    //计算企业清产核资
    calcTotal5(){
      this.total5 = this.total2 * 1.5;
      this.total5 = Math.round(this.total5);
    },
    calcTotal6(){
      this.total6 = this.total2 * 0.7;
      this.total6 = Math.round(this.total6);
    },
    calcTotal7(){
      this.total7 = Math.round(this.total * 10000 * 1.5 / 100);
      this.total8 = Math.round(this.total * 10000 * 3 / 100);
    },
    calcTotal9(){
      this.total9 = Math.round(this.total * 10000 * 0.5 / 1000);
      this.total10 = Math.round(this.total * 10000 * 2 / 1000);
    },
    reset(){
      this.total = '';
    },
    //获取当前时间
    getTime() {
      var myDate = new Date(); //获取系统当前时间
      this.years = myDate.getFullYear();
      this.month = myDate.getMonth() + 1;
      this.week = myDate.getDay();
      this.day = myDate.getDate();
      this.hourse =
        myDate.getHours() >= 10 ? myDate.getHours() : "0" + myDate.getHours();
      this.min =
        myDate.getMinutes() >= 10
          ? myDate.getMinutes()
          : "0" + myDate.getMinutes();
      this.sencond =
        myDate.getSeconds() >= 10
          ? myDate.getSeconds()
          : "0" + myDate.getSeconds();
      switch (this.week) {
        case 1:
          this.week = "一";
          break;
        case 2:
          this.week = "二";
          break;
        case 3:
          this.week = "三";
          break;
        case 4:
          this.week = "四";
          break;
        case 5:
          this.week = "五";
          break;
        case 6:
          this.week = "六";
          break;
        case 0:
          this.week = "日";
          break;
      }
    }
  },
  watch: {
    total(v, o) {
      var str = v.toString();
      var arr = str.split('.');
      if(arr.length > 1) {
        if(arr[1].length > 2) {
          var num = parseFloat(v);
          this.total =  Math.floor(num * 100) / 100;
        }
      }
      if(v > 1000000)this.total = 1000000;
      this.total1 = '';
      this.total2 = '';
      this.total3 = '';
      this.total4 = '';
      this.total5 = '';
      this.total6 = '';
      this.total7 = '';
      this.total8 = '';
      this.total9 = '';
      this.total10 = '';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.total-icon{
  height: 18px;
  margin-right: 5px;
  float: left;
  margin-top:2px;
}
div {
  box-sizing: border-box;
}
.calc-head > img {
  float: left;
}
.calc-head > span {
  font-weight: bold;
}
.head-time {
  float: right;
  margin-right: 20px;
  height: 60px;
  line-height: 60px;
}
.head-time > span {
  font-size: 12px;
}
.head-time-num {
  color: #c94f4f;
}
.head-time-icon {
  height: 12px;
  margin-right: 5px;
  float: left;
  margin-top: 25px;
}
.bg-btn {
  height: 60px;
}
.head-logo {
  height: 32px;
  margin: 14px 20px;
}
.calc-body {
  width: 600px;
  margin: auto;
  background: #f8f8f8;
}
.calc-head,
.calc-footer {
  width: 100%;
  height: 60px;
  line-height: 60px;
  overflow: hidden;
}
.calc-footer {
  border: 1px solid #e1e1e1;
  border-top: none;
}
.calc-content {
  width: 100%;
  height: calc(100% - 120px);
  background: #fff;
  border: 1px solid #e1e1e1;
  border-top: none;
  border-bottom: none;
  padding: 0 20px;
}
.calc-res {
  background: #d91d1e;
  color: #fff;
}
.calc-reset {
  background: #e1e1e1;
  color: #fff;
}
.calc-form {
  width: 100%;
  padding: 20px 0;
  overflow: hidden;
  border-bottom: 1px solid #e1e1e1;
}
.calc-form:last-child {
  border-bottom: none;
}
.calc-input {
  margin-top: 20px;
}
.calc-input > input {
  height: 40px;
  padding: 0 10px;
  border-radius: 3px;
  border: 1px solid #e1e1e1;
  width: calc(100% - 204px);
}
.calc-input > input:focus {
  outline: none;
}
.calc-input > button {
  height: 42px;
  width: 80px;
  border: none;
  border-radius: 3px;
  margin-left: 10px;
}
.calc-input > button:focus {
  outline: none;
  cursor: pointer;
}
.calc-form-item {
  float: left;
  width: calc(50% - 10px);
  position: relative;
}
.calc-form > .calc-form-item:last-child {
  margin-left: 20px;
}
.other-btn {
  width: 100%;
  border: none;
  height: 50px;
  border-radius: 3px;
  cursor: pointer;
  color: #fff;
  line-height: 50px;
  font-size: 16px;
}
.other-btn:focus {
  outline: none;
}
.btn-red {
  background: linear-gradient(top, #f96363, #c94f4f);
}
.btn-yellow {
  background: linear-gradient(top, #fbeaae, #fdb784);
}
.other-btn > img {
  padding: 0;
  margin: 0;
  height: 18px;
  vertical-align: sub;
  margin-right: 10px;
}
.calc-input-res {
  width: 100%;
  height: 42px;
  border-radius: 3px;
  border: 1px solid #e1e1e1;
}
.calc-input-res > input {
  border: none;
  border-radius: 0;
  border-right: 1px solid #e1e1e1;
  width: calc(100% - 60px);
  height: 20px;
  margin-top: 10px;
}
.calc-input-res > span {
  display: inline-block;
  width: 35px;
  font-size: 14px;
  text-align: center;
}
.calc-footer {
  font-size: 12px;
  padding: 0 20px;
}
.calc-footer > span:first-child {
  color: #d91d1e;
}
.calc-footer > span:last-child {
  float: right;
}
.calc-input-area {
  width: 100%;
  overflow: hidden;
}
.calc-input-area > div {
  float: left;
  height: 42px;
}
.calc-input-area > div.calc-input-res {
  width: calc(50% - 11px);
}
.calc-jian {
  width: 20px;
  text-align: center;
  line-height: 42px;
  margin-top: 20px;
}
.calc-jian1{display: none;}
@media screen and (max-width:1024px){
  .calc-body{
    width:100%;
  }
  .calc-footer{
    font-size: 12px;
    line-height: 30px;
  }
  .calc-footer > span{display: block;}
  .calc-footer > span:first-child{display: none}
  .calc-footer a{color: #d91d1e}
  .calc-footer > span:last-child{float: none}
  .calc-input-res{width: 100% !important;float: none !important;}
  .calc-jian{display: none;}
  .calc-jian1{display: block;text-align: center;width: 100%;padding:5px 0;font-size: 10px;}
  .calc-input-area > .calc-input-res:last-child{margin-top:0;}
  .head-time{display: none;}
}
</style>
